import { render, staticRenderFns } from "./PainterChat.vue?vue&type=template&id=a576a9ec&scoped=true"
import script from "./PainterChat.vue?vue&type=script&lang=js"
export * from "./PainterChat.vue?vue&type=script&lang=js"
import style0 from "./PainterChat.vue?vue&type=style&index=0&id=a576a9ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a576a9ec",
  null
  
)

export default component.exports